/* ag-motion.js — Armour Guards motion behaviours. Additive, fail-open, no deps. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    if (REDUCED || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-ag-reveal]').forEach(function (el) { el.classList.add('ag-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ag-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    document.querySelectorAll('[data-ag-reveal]').forEach(function (el) { io.observe(el); });
  }

  function bumpCartCount() {
    var el = document.querySelector('[data-cart-count], .cart-count, .sf__cart-count, .cart-count-bubble, .sf-cart-count');
    if (!el || REDUCED) return;
    el.style.transition = 'transform 180ms cubic-bezier(.16,1,.3,1)';
    el.style.transform = 'scale(1.35)';
    setTimeout(function () { el.style.transform = 'none'; }, 200);
  }
  function toast(msg) {
    var t = document.querySelector('.ag-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ag-toast';
      t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.style.cssText =
        'position:fixed;left:50%;bottom:calc(20px + env(safe-area-inset-bottom));' +
        'transform:translate(-50%,16px);opacity:0;z-index:120;background:#0f1111;color:#fff;' +
        'font:600 13px/1.3 -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;' +
        'padding:11px 16px;border-radius:10px;box-shadow:0 10px 30px -8px rgba(0,0,0,.4);' +
        'pointer-events:none;max-width:88vw;text-align:center;' +
        (REDUCED ? '' : 'transition:opacity 220ms ease,transform 220ms cubic-bezier(.16,1,.3,1);');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translate(-50%,0)'; });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translate(-50%,16px)'; }, 2200);
  }
  function initAtcFeedback() {
    document.addEventListener('cart:added', onAdd);
    document.addEventListener('cart:updated', onAdd);
    document.addEventListener('product:added', onAdd);
    function onAdd() {
      var btn = document.querySelector('.add-to-cart');
      if (btn && !REDUCED) { btn.classList.add('ag-added'); setTimeout(function () { btn.classList.remove('ag-added'); }, 350); }
      bumpCartCount();
      toast('Added to cart');
    }
  }

  function initStickyAtc() {
    if (REDUCED) return;
    var bar = document.querySelector('.foxify-sticky-atc, [data-sticky-atc], .f-product-form__buttons');
    if (!bar) return;
    var mo = new MutationObserver(function () {
      var visible = getComputedStyle(bar).display !== 'none' && bar.offsetParent !== null;
      if (visible && !bar.classList.contains('ag-sticky-in')) bar.classList.add('ag-sticky-in');
    });
    mo.observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  function boot() { initReveals(); initAtcFeedback(); initStickyAtc(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
